import axios from "axios";
import config from "../config";

export interface AddressAlias {
    id: number;
    aliasInput: string;
    normalizerVersion: number;
    canonicalAddressId: number;
    canonicalTraceId?: string | null;
    canonicalFullAddress?: string | null;
    status: string;
    reason?: string | null;
    createdBy: string;
    createdAt: string;
    revokedAt?: string | null;
    revokedBy?: string | null;
    revokeReason?: string | null;
}

export interface AddressAliasQueryParams {
    status?: string;
    canonicalAddressId?: number;
    offset?: number;
    limit?: number;
}

export interface AddressAliasResponse {
    items: AddressAlias[];
    page: number;
    pageSize: number;
    totalItems: number;
}

const AddressAliasService = {
    getAliases: async (params: AddressAliasQueryParams): Promise<AddressAliasResponse> => {
        const baseUrl = config.API_URL?.endsWith('/') ? config.API_URL : `${config.API_URL}/`;

        const cleanParams: Record<string, any> = {};
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                cleanParams[key] = value;
            }
        });

        try {
            const response = await axios.get(`${baseUrl}api/v1/address-aliases/aliases`, {
                params: cleanParams
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching address aliases:", error);
            throw error;
        }
    }
};

export default AddressAliasService;
